<template>
  <div>
    <div
      v-if="!isAssociatedAnotherTsId && !isTsIdAssociation && !errorMessage"
      class="carrello blocco_sfumato"
    >
      <div>
        <form id="frmLogin" action="#" method="post">
          <div class="control-group cf">
            <label class="control-label" for="loginCFPI"
              >Username: Partita Iva / Codice Fiscale</label
            >
            <div class="controls">
              <input
                id="loginCFPI"
                v-model="userName"
                type="text"
                name="cfpi"
                class="input-xlarge required cfpi"
                maxlength="50"
              />
            </div>
          </div>
          <div class="control-group cf">
            <label class="control-label" for="loginPassword">Password</label>
            <div class="controls">
              <input
                id="loginPassword"
                v-model="password"
                type="password"
                autocomplete="off"
                name="Password"
                class="input-xlarge required"
              />
            </div>
          </div>
          <div style="height: 47px">
            <input
              id="loginRicordami"
              type="checkbox"
              name="Ricordami"
              class="rdo1"
            /><span style="padding-left: 5px; padding-right: 10px"
              >Ricordami</span
            >
          </div>
          <div class="controls errorText"></div>
          <div class="control-group psw_dimenticata cf">
            <div class="row-fluid">
              <div class="span8">
                <div class="control">
                  <a
                    href="#blocco_recupera_password"
                    title=""
                    class="freccia2 fancyboxPWD"
                    >Hai dimenticato la password?</a
                  >
                </div>
              </div>
              <div class="action-container">
                <!-- <a
                href="#"
                id="aLogin"
                @click.prevent="login($event)"
                class="btnLogin button freccia_dx pull-right"
                >Login</a
              > -->
                <v-btn
                  color="#00a0dc"
                  class="text-white"
                  variant="flat"
                  rounded
                  :loading="showloading"
                  :disabled="showloading"
                  @click.prevent="login($event)"
                  >Login
                </v-btn>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <v-card v-if="isTsIdAssociation === true" color="primary" dark>
      <v-card-text>
        <span class="loader-text">
          {{ loadingMessage }}
        </span>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
    <v-card v-else-if="errorMessage !== null" class="dialog-container">
      <v-card-title> Errore di login</v-card-title>
      <v-card-text>
        <v-alert
          type="error"
          variant="tonal"
          prominent
          icon="mdi-cloud-alert"
          class="error-text"
        >
          {{ errorMessage }}
          <br />
          Si prega di contattare il supporto tecnico.
        </v-alert>
      </v-card-text>
      <v-card-actions class="action-container">
        <v-btn variant="flat" @click="onClickGoHome($event)"> Home </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-else-if="isAssociatedAnotherTsId === true"
      class="dialog-container"
    >
      <v-card-title> Anagrafica con TeamSystem ID già presente </v-card-title>
      <v-card-text>
        Esiste un TeamSystem ID differente associato a questa anagrafica
        Euroconference.
        <br />
        Desideri sovrascriverlo?
      </v-card-text>

      <v-card-actions class="action-container">
        <v-btn
          color="primary"
          variant="flat"
          @click="onClickAssociateTsId($event)"
        >
          Sovrascrivi
        </v-btn>
        <v-btn color="primary" variant="flat" @click="onClickGoHome($event)">
          Home
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          @click="onClickGoHelpDesk($event)"
        >
          Servizio Clienti
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { blogNamesMap, Blogs, PostHistoricalTypes } from '../../common/types'
import dateFormat from 'dateformat'

export default {
  name: 'EcLoginForm',
  data: () => ({
    userName: null,
    password: null,
    showloading: false,
    isIntermediateStep: null,
    isIntermediateStepBlog: null,
    isAssociatedAnotherTsId: null,
    isTsIdAssociation: null,
    loadingMessage: null,
    errorMessage: null,
  }),
  created() {
    const ecLoginForm = document.querySelector('#ec-login-form')
    if (ecLoginForm) {
      const isIntermediateStepBlog = ecLoginForm.getAttribute(
        'data-is-intermediate-step-blog'
      )
      if (isIntermediateStepBlog === 'true') {
        document.querySelector('.registration-form').style.display =
          'inline-flex'
        this.isIntermediateStep = true
        this.isIntermediateStepBlog = true
      }
    }
  },
  mounted() {
    const blogId = sessionStorage.getItem('blogId')
    if (blogId !== null) {
      this.updateFormLogo(blogNamesMap.get(+blogId))
    }
  },
  methods: {
    login(event) {
      this.showloading = true
      event.isIntermediateStep = this.isIntermediateStep
      return window
        .loginWebApiAndAccessARNew(event)
        .then(() => {
          if (this.isIntermediateStepBlog) {
            return this.apiService.usersApi
              .isAssociatedTsId()
              .then(res => {
                if (res) {
                  this.isAssociatedAnotherTsId = true
                } else {
                  return this.associateTsIdAsync(sessionStorage.getItem('tsId'))
                    .then(() => {
                      return this.multipleTsIdAssociationsAsync(
                        sessionStorage.getItem('tsId')
                      )
                    })
                    .then(res => {
                      if (res) {
                        this.errorMessage =
                          'Esiste un TeamSystem ID differente associato a questa anagrafica Euroconference.'
                      } else {
                        this.showloading = false
                        this.navigateToBlogOrEcCart()
                      }
                    })
                }
              })
              .catch(() => {
                this.errorMessage = 'Errore di associazione del Team System ID.'
              })
          } else {
            return Promise.resolve()
          }
        })
        .catch(() => {
          this.showloading = false
        })
    },
    associateTsIdAsync(tsId) {
      this.isTsIdAssociation = true
      this.loadingMessage = 'Stiamo associando il Team System ID...'
      return this.apiService.usersApi
        .associateTsId(tsId)
        .then(() => {
          this.isTsIdAssociation = null
        })
        .catch(() => {
          this.errorMessage = 'Errore di associazione del Team System ID.'
        })
    },
    onClickAssociateTsId() {
      this.isAssociatedAnotherTsId = null
      return this.associateTsIdAsync(sessionStorage.getItem('tsId'))
        .then(() => {
          return this.multipleTsIdAssociationsAsync(
            sessionStorage.getItem('tsId')
          )
        })
        .then(res => {
          if (res) {
            this.errorMessage =
              'Esiste un TeamSystem ID differente associato a questa anagrafica Euroconference.'
          } else {
            this.showloading = false
            this.navigateToBlogOrEcCart()
          }
        })
    },
    multipleTsIdAssociationsAsync(tsId) {
      return this.apiService.usersApi
        .multipleTsIdAssociations(tsId)
        .catch(() => {
          this.errorMessage =
            'Errore di controllo su associazioni multiple del Team System ID.'
        })
    },
    navigateToBlogOrEcCart() {
      if (this.blogSubscriptionDetailsAreNotEmpty()) {
        const blogId = +sessionStorage.getItem('blogId')
        const postHistoricalType = +sessionStorage.getItem('postHistoricalType')
        if (blogId === Blogs.ECNews) {
          if (postHistoricalType === PostHistoricalTypes.Recent) {
            window.location.href = sessionStorage.getItem('redirectUrl')
          } else if (postHistoricalType === PostHistoricalTypes.Historical) {
            window.location.href =
              window.websiteConfig.blogSubscriptionGatewayUrl
          }
        }
      } else if (sessionStorage.getItem('blogRegistrationOnlyRedirectUrl')) {
        const link = `${sessionStorage.getItem(
          'blogRegistrationOnlyRedirectUrl'
        )}?encParam=${this.computeRedirecUrl()}`
        window.open(link, '_self')
      }
    },
    blogSubscriptionDetailsAreNotEmpty() {
      return (
        sessionStorage.getItem('tsId') &&
        sessionStorage.getItem('blogId') &&
        sessionStorage.getItem('postHistoricalType') &&
        sessionStorage.getItem('redirectUrl')
      )
    },
    onClickGoHome() {
      window.location.replace(window.websiteConfig.defaultBlogOriginUrl)
    },
    onClickGoHelpDesk() {
      window.location.replace(window.websiteConfig.helpDeskUrl)
    },
    updateFormLogo(logo) {
      let logoSrc = './img/logo.png'
      let height = '50px'
      let titoloBlog = ''
      let descrizioneBlog = ''
      if (logo === 'ecnews') {
        titoloBlog = 'News'
        logoSrc = './img/ecnews.png'
        height = '110px'
        descrizioneBlog =
          'Inserisci tutte le informazioni per completare la registrazione gratuita al blog di Euroconference News, l’informazione quotidiana da Professionista a Professionista.'
      } else if (logo === 'eclegal') {
        logoSrc = './img/eclegal.png'
        height = '110px'
        titoloBlog = 'Legal'
        descrizioneBlog =
          'Inserisci tutte le informazioni per completare la registrazione al blog di Euroconference Legal, il settimanale di aggiornamento gratuito per l’Avvocato.'
      } else if (logo === 'eclavoro') {
        logoSrc = './img/ecLavoro.png'
        height = '110px'
        titoloBlog = 'Lavoro'
        descrizioneBlog =
          'Inserisci tutte le informazioni per completare la registrazione al blog di Euroconference Lavoro, il quotidiano gratuito di Centro Studi Lavoro e Previdenza - Euroconference'
      }

      document.querySelector('#logo').src = logoSrc
      document.querySelector('#logo').style.height = height
      document.querySelector('#blog-name').innerHTML = titoloBlog
      document.querySelector('#blog-description').innerHTML = descrizioneBlog
    },
    computeRedirecUrl() {
      var timestamp = dateFormat(new Date(), 'yyyymmddHHMMss')
      return this.utf8_to_b64(
        this.utf8_to_b64(`${timestamp}|${sessionStorage.getItem('tsId')}`)
      )
    },
    // login(event) {
    //   return this.getTokenByFiscalCodeAsync(this.userName, this.password)
    //     .then(() => {
    //       return window.AccediARNew(event)
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    // getTokenByFiscalCodeAsync(userName, password) {
    //   return this.apiService.tokensApi
    //     .getTokenByFiscalCode(userName, password)
    //     .then(res => {
    //       this.userId = res.headers.idanagrafica
    //       localStorage.setItem('WebApiToken', res.headers.token)
    //     })
    //     .catch(() => {
    //       throw new Error('Errore durante il recupero del token.')
    //     })
    // }
  },
}
</script>

<style scoped>
.action-container {
  display: flex;
  justify-content: right;
}

.dialog-container {
  padding: 1rem;
  /* padding-top: 3rem; */
}

.error-text {
  font-size: 1rem;
}
</style>
